module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_TICKETING
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("Tikecting and POS")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_MEMBERSHIP
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Membership")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_LOYALTY
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_3",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Loyalty")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_TICKETING
    },
    attrs: {
      "id": "tab_1"
    }
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "col-md-4",
    on: {
      "click": _vm.onReport
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    on: {
      "click": _vm.onRevenueReport
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    on: {
      "click": _vm.onReportSalesPOS
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    on: {
      "click": _vm.onReportSalesPOSNet
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    on: {
      "click": _vm.onReportGoodsMovement
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    on: {
      "click": _vm.onReportProductSoldList
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    on: {
      "click": _vm.onReportProductSoldSUmmary
    }
  }, [_vm._m(6)])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_MEMBERSHIP
    },
    attrs: {
      "id": "tab_2"
    }
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "col-md-4",
    on: {
      "click": _vm.onReportMembershipTypeSummary
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    on: {
      "click": _vm.onReportMemberNameList
    }
  }, [_vm._m(8)])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_LOYALTY
    },
    attrs: {
      "id": "tab_3"
    }
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "col-md-4",
    on: {
      "click": _vm.onReportLoyaltySummaryDaily
    }
  }, [_vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    on: {
      "click": _vm.onReportLoyaltyCustomerPointSummary
    }
  }, [_vm._m(10)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modal-view-file"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "height": "500px",
      "padding": "5px"
    }
  }, [(_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "reportViewer"
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border": "1px"
    },
    attrs: {
      "id": "viewer"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "reportParams"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputFromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "fromDate",
      "value": _vm.formRepParams.fromDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'fromDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedFromDate
    }
  }), _vm._v(" "), _vm._m(11)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "toDate",
      "value": _vm.formRepParams.toDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'toDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedToDate
    }
  }), _vm._v(" "), _vm._m(12)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("Group By")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupBy),
      expression: "groupBy"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.groupBy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listGroupBy), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                            " + _vm._s(row.name) + "\n                          ")])
  }))])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadXls()
      }
    }
  }, [_vm._v("Download as Excel")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPreviewPdf()
      }
    }
  }, [_vm._v("View")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPrintPdf()
      }
    }
  }, [_vm._v("Print")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modalRevenueReportParams"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "100%",
      "height": "600px",
      "padding": "5px"
    }
  }, [(_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "viewer"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "reportParams"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputPaymentDateFromRevenue"
    }
  }, [_vm._v("Payment Date (From)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "inputPaymentDateFromRevenue",
      "value": _vm.reportRevenueParams.paymentDateFrom,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'inputPaymentDateFromRevenue'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedFromDate
    }
  }), _vm._v(" "), _vm._m(13)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputPaymentDateToRevenue"
    }
  }, [_vm._v("Payment Date (To)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "inputPaymentDateToRevenue",
      "value": _vm.reportRevenueParams.paymentDateTo,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'inputPaymentDateToRevenue'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedToDate
    }
  }), _vm._v(" "), _vm._m(14)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputBookingDateFromRevenue"
    }
  }, [_vm._v("Booking Date (From)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "inputBookingDateFromRevenue",
      "value": _vm.reportRevenueParams.bookingDateFrom,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'inputBookingDateFromRevenue'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedFromDate
    }
  }), _vm._v(" "), _vm._m(15)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputBookingDateToRevenue"
    }
  }, [_vm._v("Booking Date (To)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "inputBookingDateToRevenue",
      "value": _vm.reportRevenueParams.bookingDateTo,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'inputBookingDateToRevenue'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedToDate
    }
  }), _vm._v(" "), _vm._m(16)], 1)])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.downloadRevenueReport()
      }
    }
  }, [_vm._v("Download")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modalReportSalesPOSParams"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "100%",
      "height": "600px",
      "padding": "5px"
    }
  }, [(_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "viewerPOS"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "reportParams"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputFromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "fromDate",
      "value": _vm.formRepParams.fromDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'fromDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedFromDate
    }
  }), _vm._v(" "), _vm._m(17)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "toDate",
      "value": _vm.formRepParams.toDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'toDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedToDate
    }
  }), _vm._v(" "), _vm._m(18)], 1)])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadXls()
      }
    }
  }, [_vm._v("Download as Excel")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPreviewPdf()
      }
    }
  }, [_vm._v("View")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPrintPdfPOS()
      }
    }
  }, [_vm._v("Print")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modalReportSalesPOSNetParams"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "100%",
      "height": "600px",
      "padding": "5px"
    }
  }, [(_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "viewerPOSNet"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "reportParams"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputFromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "fromDate",
      "value": _vm.formRepParams.fromDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'fromDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedFromDate
    }
  }), _vm._v(" "), _vm._m(19)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "toDate",
      "value": _vm.formRepParams.toDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'toDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedToDate
    }
  }), _vm._v(" "), _vm._m(20)], 1)])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadXls()
      }
    }
  }, [_vm._v("Download as Excel")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPreviewPdf()
      }
    }
  }, [_vm._v("View")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPrintPdfPOS()
      }
    }
  }, [_vm._v("Print")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modalReportGoodsMovementParams"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "100%",
      "height": "600px",
      "padding": "5px"
    }
  }, [(_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "viewerGoodsMovement"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "reportParams"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputFromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "fromDate",
      "value": _vm.formRepParams.fromDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'fromDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedFromDate
    }
  }), _vm._v(" "), _vm._m(21)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "toDate",
      "value": _vm.formRepParams.toDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'toDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedToDate
    }
  }), _vm._v(" "), _vm._m(22)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("Product Category")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productCategoryId),
      expression: "productCategoryId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.productCategoryId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listProductCategory), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                            " + _vm._s(row.name) + "\n                          ")])
  }))])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadXls()
      }
    }
  }, [_vm._v("Download as Excel")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPreviewPdf()
      }
    }
  }, [_vm._v("View")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPrintPdfGoodsMovement()
      }
    }
  }, [_vm._v("Print")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modalReportLoyaltySummaryParams"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "100%",
      "height": "600px",
      "padding": "5px"
    }
  }, [(_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "viewerLoyaltySummary"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "reportParams"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputFromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "fromDate",
      "value": _vm.formRepParams.fromDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'fromDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedFromDate
    }
  }), _vm._v(" "), _vm._m(23)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "toDate",
      "value": _vm.formRepParams.toDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'toDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedToDate
    }
  }), _vm._v(" "), _vm._m(24)], 1)])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadXls()
      }
    }
  }, [_vm._v("Download as Excel")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPreviewPdf()
      }
    }
  }, [_vm._v("View")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modalReportLoyaltyCustomerPointSummaryParams"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "100%",
      "height": "600px",
      "padding": "5px"
    }
  }, [(_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "viewerLoyaltyCustomerPoint"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "reportParams"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputOperator"
    }
  }, [_vm._v("Operator")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operator),
      expression: "operator"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputOperator"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.operator = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.operatorOptions), function(op, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": op.id
      }
    }, [_vm._v("\n                            " + _vm._s(op.name) + "\n                          ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputValue"
    }
  }, [_vm._v("Total Point")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.totalpoint),
      expression: "totalpoint",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "inputValue",
      "placeholder": "Masukkan nilai numerik"
    },
    domProps: {
      "value": (_vm.totalpoint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalpoint = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadXls()
      }
    }
  }, [_vm._v("Download as Excel")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPreviewPdf()
      }
    }
  }, [_vm._v("View")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modalReportMembershipSummaryParams"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "100%",
      "height": "600px",
      "padding": "5px"
    }
  }, [(_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "viewerMembershipSummary"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "reportParams"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputFromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "fromDate",
      "value": _vm.formRepParams.fromDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'fromDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedFromDate
    }
  }), _vm._v(" "), _vm._m(25)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "toDate",
      "value": _vm.formRepParams.toDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'toDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedToDate
    }
  }), _vm._v(" "), _vm._m(26)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("Product Category")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productCategoryId),
      expression: "productCategoryId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.productCategoryId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listProductCategory), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                            " + _vm._s(row.name) + "\n                          ")])
  }))])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPreviewPdf()
      }
    }
  }, [_vm._v("View")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modalReportMembershipDetailParams"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "100%",
      "height": "600px",
      "padding": "5px"
    }
  }, [(_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "viewerMembershipDetail"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "reportParams"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputFromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "fromDate",
      "value": _vm.formRepParams.fromDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'fromDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedFromDate
    }
  }), _vm._v(" "), _vm._m(27)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "toDate",
      "value": _vm.formRepParams.toDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'toDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedToDate
    }
  }), _vm._v(" "), _vm._m(28)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("Product Category")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productCategoryId),
      expression: "productCategoryId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.productCategoryId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listProductCategory), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                            " + _vm._s(row.name) + "\n                          ")])
  }))])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPreviewPdf()
      }
    }
  }, [_vm._v("View")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modalReportProductSoldSummaryParams"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "100%",
      "height": "600px",
      "padding": "5px"
    }
  }, [(_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "viewerProductSoldSummary"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "reportParams"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputFromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "fromDate",
      "value": _vm.formRepParams.fromDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'fromDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedFromDate
    }
  }), _vm._v(" "), _vm._m(29)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "toDate",
      "value": _vm.formRepParams.toDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'toDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedToDate
    }
  }), _vm._v(" "), _vm._m(30)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "comboCashier"
    }
  }, [_vm._v("Cashier")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select2', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": 'comboCashierSummary',
      "options": _vm.listCashier,
      "value": _vm.cashierSelected
    }
  })], 1)])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadXls()
      }
    }
  }, [_vm._v("Download as Excel")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPreviewPdf()
      }
    }
  }, [_vm._v("View")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPrintPdfProductSoldSummary()
      }
    }
  }, [_vm._v("Print")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modalReportProductSoldListParams"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "100%",
      "height": "600px",
      "padding": "5px"
    }
  }, [(_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "viewerProductSoldList"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "reportParams"
    }
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputFromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "fromDate",
      "value": _vm.formRepParams.fromDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'fromDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedFromDate
    }
  }), _vm._v(" "), _vm._m(31)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "toDate",
      "value": _vm.formRepParams.toDate,
      "format": _vm.DATE_FORMAT,
      "input-attr": {
        'id': 'toDate'
      },
      "input-style": {
        'width': '100%'
      },
      "after-picked": _vm.onPickedToDate
    }
  }), _vm._v(" "), _vm._m(32)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputToDate"
    }
  }, [_vm._v("Product Category")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productCategoryId),
      expression: "productCategoryId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.productCategoryId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listProductCategory), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                            " + _vm._s(row.name) + "\n                          ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "comboCashier"
    }
  }, [_vm._v("Cashier")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select2', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": 'comboCashier',
      "options": _vm.listCashier,
      "value": _vm.cashierSelected
    }
  })], 1)])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadXls()
      }
    }
  }, [_vm._v("Download as Excel")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_PARAMS) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPreviewPdf()
      }
    }
  }, [_vm._v("View")]) : _vm._e(), _vm._v(" "), (_vm.viewTypeReport == _vm.VIEW_REPORT) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPrintPdfGoodsMovement()
      }
    }
  }, [_vm._v("Print")]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Laporan Penjualan Online")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('blockquote', [_c('p', [_vm._v("Detail data penjualan tiket berdasarkan project ")]), _vm._v(" "), _c('p', [_vm._v("dan tanggal pembelian serta tanggal booking / proses date")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Laporan Penerimaan")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('blockquote', [_c('p', [_vm._v("Detail data penerimaan berdasarkan project ")]), _vm._v(" "), _c('p', [_vm._v("dan tanggal pembelian ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Laporan Penjualan via POS")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('blockquote', [_c('p', [_vm._v("Laporan penjualan khusus untuk transaksi yg dihasilkan dari system POS (Point of Sales)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Laporan Penjualan via POS (Net Amount)")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('blockquote', [_c('p', [_vm._v("Laporan penjualan khusus untuk transaksi yg dihasilkan dari system POS (Point of Sales)")]), _vm._v(" "), _c('p', [_vm._v("per Invoice dan net amount")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Laporan Stock Barang")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('blockquote', [_c('p', [_vm._v("Laporan pergerakan stock barang")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Laporan Product Sold List")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('blockquote', [_c('p', [_vm._v("Laporan Daftar penjualan bedasarkan kategori dan user secara realtime yg datanya diambil dari POS")]), _vm._v(" "), _c('p', [_vm._v("Berdasarkan parameter tanggal transaksi dan kategori di POS")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Laporan Summary Penjualan")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('blockquote', [_c('p', [_vm._v("Laporan summary penjualan secara realtime yg datanya diambil dari POS")]), _vm._v(" "), _c('p', [_vm._v("Berdasarkan parameter tanggal transaksi di POS")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Membership Type and Status Analysis")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('blockquote', [_c('p', [_vm._v("Menampilkan total membership per membership type dan status")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Member Name List")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('blockquote', [_c('p', [_vm._v("Menampilkan detail membership")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Laporan Loyaty Per Hari")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('blockquote', [_c('p', [_vm._v("Menampilkan total loyalty per hari")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Laporan Loyalty Customer Point")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('blockquote', [_c('p', [_vm._v("Menampilkan total point yang didapat customer")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon ion-calendar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03865189"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Report.vue
// module id = 727
// module chunks = 1